import { AgGridModule } from '@ag-grid-community/angular';
import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { PageTitleModule } from 'app/layout/components/page-title/page-title.module';
import { AnalyticsModule } from 'app/main/analytics/analytics.module';
import { ProviderPcatComponent } from 'app/main/provider/provider-pcat/provider-pcat.component';
import { ProviderProvComponent } from 'app/main/provider/provider-prov/provider-prov.component';
import { ProviderGroupsComponent } from 'app/main/provider/provider-groups/provider-groups.component';
import { ProviderRuleComponent } from 'app/main/provider/provider-rule/provider-rule.component';
import { ProviderBreakdownComponent } from 'app/main/provider/provider-breakdown/provider-breakdown.component';
import { ProviderComponent } from 'app/main/provider/provider.component';
import { MaterialModule } from 'app/main/material.module';
import { CheckboxCellComponent } from 'app/main/shared/checkbox-cell/checkbox-cell.component';
// tslint:disable-next-line: max-line-length
import { KeyValueCellRendererComponent } from 'app/main/shared/key-value-cell-renderer/key-value-cell-renderer.component';
import { MomentModule } from 'ngx-moment';
import { CancelConfirmButtonsModule } from 'app/main/shared/cancel-confirm-buttons/cancel-confirm-buttons.module';
import { ColorCellComponent, ColorCellModule } from 'app/main/shared/color-cell';

import { ProviderResolver } from './provider.resolver';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        ProviderComponent,
        ProviderPcatComponent,
        ProviderProvComponent,
        ProviderGroupsComponent,
        ProviderRuleComponent,
        ProviderBreakdownComponent,
    ],
    imports: [
        FuseSharedModule,
        MaterialModule,
        AnalyticsModule,
        CancelConfirmButtonsModule,
        ColorCellModule,
        RouterModule,
        
        // AG Grid
        AgGridModule.withComponents([KeyValueCellRendererComponent, CheckboxCellComponent, ColorCellComponent]),

        PageTitleModule,
        MomentModule,
    ],
    exports: [
        ProviderComponent,
        ProviderPcatComponent,
        ProviderProvComponent,
        ProviderGroupsComponent,
        ProviderRuleComponent,
        ProviderBreakdownComponent,
    ],
    providers: [ProviderResolver]
})
export class ProviderModule {}
